<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style lang="css">
#app {
  /* width: 1920px; */
  width: 100%;
}
</style>
